let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fC3D2")).then(() => parcelRequire('a0Cao'));